import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Tags from "../elements/Tags"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". . culture-1 culture-1" "culture-2 culture-2 . ." ". . culture-3 culture-3" "culture-4 culture-4 . ." ". . culture-5 culture-5";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
    align-self: flex-end;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  .culture-3 {
    grid-area: culture-3;
  }
  .culture-4 {
    grid-area: culture-4;
  }
  .culture-5 {
    grid-area: culture-5;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." "event-3 event-3 event-2 event-2" "event-3 event-3 . ." ". . culture-1 ." ". . culture-1 culture-2" ". culture-3 . culture-2" ". culture-3 culture-4 ." ". culture-5 culture-4 ." ". culture-5 . .";
  }
  @media (min-width: 1200px) {
  }
`

const August = () => {
  const data = useStaticQuery(graphql`
    query {
      augustEventOne: file(relativePath: { eq: "events/august/event-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustEventTwo: file(relativePath: { eq: "events/august/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1080, maxHeight: 1080, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustEventThree: file(
        relativePath: { eq: "events/august/event-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 547, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustCultureOne: file(
        relativePath: { eq: "events/august/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 555, maxHeight: 562, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustCultureTwo: file(
        relativePath: { eq: "events/august/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 523, maxHeight: 557, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustCultureThree: file(
        relativePath: { eq: "events/august/culture-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustCultureFour: file(
        relativePath: { eq: "events/august/culture-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      augustCultureFive: file(
        relativePath: { eq: "events/august/culture-5.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="august">
      <Grid>
        <Block className="event-1">
          <Photo img={data.augustEventOne} maxWidth={500} maxHeight={500} />
          <h4 style={{ maxWidth: 500 }}>
            Teamgeek designed the identity and posters for Sound Idea Sessions -
            a growth hacking masterclass featuring wunderkind{" "}
            <a
              href="https://ryanholiday.net/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Ryan Holiday
            </a>{" "}
            and SA’s own{" "}
            <a
              href="https://open.spotify.com/artist/6wMr4zKPrrR0UVz08WtUWc?si=0b3TKmjFT0CxElmdg3r5bQ"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Black Coffee
            </a>
            .
          </h4>
        </Block>

        <Block className="event-2">
          <Photo img={data.augustEventTwo} maxWidth={1080} maxHeight={1080} />
          <h4 style={{ maxWidth: 1080 }}>
            We took the grungy look online with this epic{" "}
            <a
              href="https://www.soundideasessions.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              website
            </a>
            .
          </h4>
          <Tags maxWidth={1080} words={["react", "gatsbyjs", "gsap"]} />
        </Block>
        <Block className="event-3">
          <Photo img={data.augustEventThree} maxWidth={500} maxHeight={547} />
          <h4 style={{ maxWidth: 500 }}>
            Together with our friends from{" "}
            <a
              href="https://brainfarm.co.za/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              BrainFarm
            </a>{" "}
            and{" "}
            <a
              href="https://twitter.com/Percy_Maimela_?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Percy Maimela{" "}
            </a>
            we broke an Official Guinness World Record™. We were pretty chilled
            about it 😱😱😱
          </h4>
        </Block>

        <Block className="culture-1">
          <Photo img={data.augustCultureOne} maxWidth={555} maxHeight={562} />
          <h4 style={{ maxWidth: 555 }}>
            Bevan hosted a guest lecture at the University of Pretoria.
          </h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.augustCultureTwo} maxWidth={523} maxHeight={557} />
          <h4 style={{ maxWidth: 523, fontStyle: "italic" }}>
            He plugged the Geeks shamelessly.
          </h4>
        </Block>
        <Block className="culture-3">
          <Photo img={data.augustCultureThree} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            Luan, our creative tech lead, had a birthday.
          </h4>
        </Block>
        <Block className="culture-4">
          <Photo img={data.augustCultureFour} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>So did Sphiwe, our PHP whizkid.</h4>
        </Block>
        <Block className="culture-5">
          <Photo img={data.augustCultureFive} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            And Marcus, our business partner in London. So much cake.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default August
